import { Box, Typography } from "@mui/material";

const WidgetHeaderRow = ({ title, count }) => (
    <Box
        sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            pb: "12px",
            pl: "8px",
            pr: "6px",
            flexShrink: 0,
        }}
    >
        <Typography
            sx={{
                fontSize: 14,
                fontWeight: 600,
                fontFamily: "Inter Tight, sans-serif",
                color: "text.primary",
                lineHeight: 1,
                flexShrink: 0,
            }}
        >
            {title}
        </Typography>
        {count != null && (
            <Box
                sx={{
                    bgcolor: "background.default",
                    width: 16,
                    height: 16,
                    borderRadius: "1000px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    flexShrink: 0,
                }}
            >
                <Typography
                    sx={{
                        fontSize: 10,
                        color: "text.secondary",
                        fontFamily: "Inter Tight, sans-serif",
                        lineHeight: 1,
                    }}
                >
                    {count}
                </Typography>
            </Box>
        )}
    </Box>
);

export default WidgetHeaderRow;
